<p>parent-opening-dialog works!</p>
